import React from "react";
import Modal from "./Modal";
import Button from "./Button";
import { useTranslation } from "react-i18next";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText,
  cancelText,
  danger = true,
}) => {
  const { t } = useTranslation("UI");

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title || t("confirm_title")}
    >
      <div className="space-y-4">
        <p className="text-gray-700">
          {description || t("confirm_description")}
        </p>

        <div className="flex justify-end gap-3">
          <Button variant="secondary" onClick={onClose}>
            {cancelText || t("cancel")}
          </Button>

          <Button
            variant={danger ? "danger" : "primary"}
            onClick={onConfirm}
          >
            {confirmText || t("confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;